var map = {
	"./de.json": [
		67679,
		7679
	],
	"./en.json": [
		32149,
		2149
	],
	"./fr.json": [
		97574,
		7574
	],
	"./it.json": [
		87211,
		7211
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 49993;
module.exports = webpackAsyncContext;